var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-list-card.css';
import { Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import renderLegends from '../util/render-legends';
import ApprovalListCardAPI from './approval-list-card-api';
import { Situation } from './approval-list-card-types';
let ApprovalListCard = class ApprovalListCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick, id, processId, releaseDate, situation, reason, totalApprovalValue, originStock, targetStock, documentNumber, usernameOpinion, observation } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        id, processId, releaseDate, situation, reason, totalApprovalValue, originStock, targetStock, documentNumber, usernameOpinion, observation,
                    },
                }));
            }
        };
    }
    renderIndicator() {
        return (React.createElement("div", { className: "approval-list-card__indicator" }, this.renderIndicatorColorStatus()));
    }
    renderIndicatorColorStatus() {
        const { situation } = this.props;
        switch (situation) {
            case Situation.APPROVED:
                return React.createElement("div", { className: "approval-list-card__indicator-approved" });
            case Situation.CLOSED:
                return React.createElement("div", { className: "approval-list-card__indicator-closed" });
            case Situation.FORWARDED:
                return React.createElement("div", { className: "approval-list-card__indicator-forwarded" });
            case Situation.PENDING:
                return React.createElement("div", { className: "approval-list-card__indicator-pending" });
            case Situation.OPINION:
                return React.createElement("div", { className: "approval-list-card__indicator-waiting-response-opinion" });
            default:
                return React.createElement("div", { className: "approval-list-card__indicator-disapproved" });
        }
    }
    getOriginByType() {
        const { origin } = this.props;
        switch (origin) {
            case 'O':
                return MessageService.translate('approvals.type.buy-order');
            case 'S':
                return MessageService.translate('approvals.type.request-buy');
            case 'R':
                return MessageService.translate('approvals.type.request-material');
            case 'N':
                return MessageService.translate('approvals.type.invoice');
            case 'C':
                return MessageService.translate('approvals.type.purchase-quote');
            case 'L':
                return MessageService.translate('approvals.type.bidding-registration');
            default:
                return MessageService.translate('approvals.table-header-approval-no-origin');
        }
    }
    render() {
        const { id, processId, releaseDate, documentNumber, establishment, } = this.props;
        const releaseDateFmt = ModelService.format('date', releaseDate, { type: 'date' });
        return (React.createElement(Card, { width: 12, transparent: false, className: "approval-list-card", uuid: generateUUID(), selectionType: SelectionType.SINGLE, superscription: renderLegends() },
            this.renderIndicator(),
            React.createElement("div", { className: "approval-list-card__info", onClick: () => this.onClick() },
                React.createElement("div", { className: "approval-list-card__info-value" },
                    React.createElement("span", { className: "approval-list-card__info-label" },
                        MessageService.translate('approvals.label'),
                        ":"),
                    " ",
                    id),
                React.createElement("div", { className: "approval-list-card__info-value" },
                    React.createElement("span", { className: "approval-list-card__info-label" },
                        MessageService.translate('approvals.filtered-list-document'),
                        ":"),
                    " ",
                    documentNumber),
                React.createElement("div", { className: "approval-list-card__info-value" },
                    React.createElement("span", { className: "approval-list-card__info-label" },
                        MessageService.translate('tws.spotlight.establishment'),
                        ":"),
                    " ",
                    establishment),
                React.createElement("div", { className: "approval-list-card__info-value" },
                    React.createElement("span", { className: "approval-list-card__info-label" },
                        MessageService.translate('approvals.table-header-process-id'),
                        ":"),
                    " ",
                    processId),
                React.createElement("div", { className: "approval-list-card__info-value" },
                    React.createElement("span", { className: "approval-list-card__info-label" },
                        MessageService.translate('approvals.table-header-approval-date'),
                        ":"),
                    " ",
                    releaseDateFmt),
                React.createElement("div", { className: "approval-list-card__info-value" },
                    React.createElement("span", { className: "approval-list-card__info-label" },
                        MessageService.translate('approvals.table-header-approval-origin'),
                        ":"),
                    " ",
                    this.getOriginByType()))));
    }
};
ApprovalListCard.propTypes = {
    id: number,
    onClick: eventListener,
    origin: string,
    processId: number,
    reason: string,
    releaseDate: string,
    situation: string,
    tableId: string,
    totalApprovalValue: number,
    originStock: string,
    targetStock: string,
    documentNumber: number,
    usernameOpinion: string,
    observation: string,
};
ApprovalListCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalListCardAPI })
], ApprovalListCard);
export default ApprovalListCard;
//# sourceMappingURL=approval-list-card.js.map